module.exports = __webpack_public_path__ + "img/review.c3395965.svg";